<template>
  <div
    v-if="files.length"
    class="flex flex-row text-[14px] px-[15px] py-[12px] gap-2"
  >
    <ItemFile
      v-for="(item, index) of files"
      :item="item"
      :index="index"
      @close="removeFileByIndex(index)"
      :visible-close="true"
      :key="item.name"
    />
  </div>
</template>

<script>
import ItemFile from "./ItemFile.vue";

export default {
  components: {
    ItemFile,
  },
  emits: ["remove-file"],
  props: {
    files: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    removeFileByIndex(index) {
      this.$emit("remove-file", index);
    },
  },
};
</script>
